import React from "react";
import OutsideOrgSingleUserContent from "../components/users/outside-org-single-user-content";

const OutsideOrgSingleUser = () => {
  return <OutsideOrgSingleUserContent />;
};

export default OutsideOrgSingleUser;
